import React from 'react';
import Banner from '../Common/Banner';
import call from "../Core/Services";

import DocumentMeta from 'react-document-meta';

class Contact extends React.Component {
	
    constructor( props ) {
        super( props );

        this.state = {
            message : ''
        };
    }

    submitForm = ( e ) => {
        
        e.preventDefault();

        let formData = {
            'name'      : this.refs.fullName.value,
            'email'     : this.refs.email.value,
            'phone'     : this.refs.phone.value,
            'comment'   : this.refs.comment.value,
            'category'  : 'CONTACT',
        };

        call.submitForm( formData, () => {
            
            this.refs.fullName.value    = '';
            this.refs.email.value       = '';
            this.refs.phone.value       = '';
            this.refs.comment.value     = '';
    
            this.setState({
                message: 'Tak for din besked, vi svarer som regel i løbet af få timer'
            });

            setTimeout( () => {                
                this.setState({
                    message: ''
                });
            }, 10000)

        });

    }

    render() {
    
        const meta = {
            title:          'Hvis du har et spørgsmål',
            description:    'I København er cykel en del af vores hverdag, hvis du gerne vil leve som en sand københavner kan du ikke undgå din cykel. Men hvad gør du når din cykel er til reparation eller mangler du bare en cykel for få dage?. Alaska cykler har den billigste løsning til denne udfordring.',
            canonical:      window.location.href,
            meta: {
                charset:    'utf-8',
                name: {
                    keywords: 'cykeludlejning i københavn, billige cykler til leje, leje en cykel københavn'
                }
            }
        };

        return (
			<div className="contact-page">
                
                <DocumentMeta {...meta} />

                <Banner 
					pageName='Kontakt Os' 
					pageID='contact' 
					pageDesc='Hvis du har et spørgsmål' 
					url='http://res.cloudinary.com/dttrnjoc5/image/upload/c_fill,h_800,q_50,w_1600/v1510589481/backgrounds/cf_silhouettes.jpg' />

                <div className="scroll-stop"></div>

                <div className="container contact-main-section">
                    <div className="row contact-cards-row">
                        {/* Left Column: Store Info & Opening Hours */}
                        <div className="col-md-5 col-sm-12">
                            <div className="contact-info-card">
                                <span className="section-overline">BESØG ELLER RING TIL OS</span>
                                <h3>Kontaktinformation</h3>
                                <p className="info-sub">
                                    Kig forbi vores fysiske butik og værksted ved Husum Torv, eller kontakt os direkte pr. telefon eller e-mail.
                                </p>

                                <ul className="contact-details-list">
                                    <li>
                                        <span className="icon-wrap"><i className="pe-7s-map-marker" /></span>
                                        <div className="detail-text">
                                            <strong>Butik &amp; Værksted</strong>
                                            <span>Islevhusvej 7, 2700 Brønshøj</span>
                                        </div>
                                    </li>
                                    <li>
                                        <span className="icon-wrap"><i className="pe-7s-call" /></span>
                                        <div className="detail-text">
                                            <strong>Telefon</strong>
                                            <a href="tel:+4571873167">+45 71 87 31 67</a>
                                        </div>
                                    </li>
                                    <li>
                                        <span className="icon-wrap"><i className="pe-7s-mail" /></span>
                                        <div className="detail-text">
                                            <strong>E-mail</strong>
                                            <a href="mailto:alaskacykler@mail.com">alaskacykler@mail.com</a>
                                        </div>
                                    </li>
                                    <li>
                                        <span className="icon-wrap"><i className="pe-7s-id" /></span>
                                        <div className="detail-text">
                                            <strong>CVR-nummer</strong>
                                            <span>38971069</span>
                                        </div>
                                    </li>
                                </ul>

                                <div className="opening-hours-box">
                                    <h4><i className="pe-7s-clock" /> Åbningstider</h4>
                                    <div className="hours-row">
                                        <span>Mandag – Fredag</span>
                                        <strong>09:00 – 18:00</strong>
                                    </div>
                                    <div className="hours-row">
                                        <span>Lørdag</span>
                                        <strong>10:00 – 15:00</strong>
                                    </div>
                                    <div className="hours-row">
                                        <span>Søndag &amp; Helligdage</span>
                                        <strong>Lukket</strong>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Right Column: Contact Form */}
                        <div className="col-md-7 col-sm-12">
                            <div className="contact-form-card">
                                <span className="section-overline">SKRIV TIL OS</span>
                                <h3>Send os en besked</h3>
                                <p className="form-sub">
                                    Har du spørgsmål til en cykel, reparation eller cykeludlejning? Udfyld formularen herunder, så svarer vi som regel i løbet af få timer.
                                </p>

                                <div className={ this.state.message ? 'alert alert-success show' : 'alert alert-success' }>
                                    <a className="close" onClick={ () => this.setState({message: '' }) } >&times;</a>
                                    { this.state.message }
                                </div>

                                <form id="contact-form" onSubmit={ this.submitForm } method="post">
                                    <div className="row">
                                        <div className="form-group col-md-6">
                                            <label className="field-label" htmlFor="first-name">Dit Navn *</label>
                                            <input type="text" id="first-name" ref="fullName" required name="first-name" placeholder="Indtast dit navn" minLength={3} maxLength={35} className="form-control" />
                                            <span className="error" />
                                        </div>
                                        <div className="form-group col-md-6">
                                            <label className="field-label" htmlFor="phone-number">Telefonnummer *</label>
                                            <input type="number" id="phone-number" ref="phone" required name="phone-number" placeholder="F.eks. 71 87 31 67" className="form-control" />
                                            <span className="error" />
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="form-group col-md-12">
                                            <label className="field-label" htmlFor="email">E-mail Adresse *</label>
                                            <input type="email" id="email" required ref="email" name="email" placeholder="din@email.dk" minLength={3} maxLength={50} className="form-control" />
                                            <span className="error" />
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="form-group col-sm-12">
                                            <label className="field-label" htmlFor="enquiry_details">Din Besked *</label>
                                            <textarea id="enquiry_details" required ref="comment" name="enquiry_details" className="form-control" minLength={10} maxLength={500} rows={5} placeholder="Skriv dit spørgsmål eller din forespørgsel her..." />
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="form-group col-xs-12 col-sm-5">
                                            <input type="submit" name="Submit" className="btn btn-primary btn-block" defaultValue="Send Besked" />
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Full-width Google Map Section */}
                <div className="contact-map-section">
                    <div className="google-map">
                        <iframe 
                            title="Alaska Cykler Kort"
                            src="https://www.google.com/maps/embed?pb=!1m23!1m12!1m3!1d7560.621761616126!2d12.45867759520137!3d55.710086285166014!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!4m8!3e6!4m0!4m5!1s0x46525198fb24a793%3A0xeee9996ee24762b!2salaska+cykler!3m2!1d55.7113902!2d12.4717753!5e0!3m2!1sen!2sin!4v1511686769385" 
                            width="600" 
                            height="450" 
                            frameBorder="0" 
                            style={{border:0}} 
                            allowFullScreen></iframe>
                    </div>
                </div>

			</div>
		);
	}
}

export default Contact;




// WEBPACK FOOTER //
// ./src/Pages/Contact.js